import BaseFormPresenter from "../../../../components/common/BaseFormPresenter";

class OtherDeductionFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }
}

export default OtherDeductionFormPresenter;
